import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs';
import {
    GetAllRequests,
    CreateTravelForm,
    GetSingleTravelRequest,
    GetTravelRequestByUser,
    GetTravelRequestByApprovers
} from './action';
import { IApprovalTravelRequest, ITravelRequest } from './interface';
import { TravelRequetService } from './requests.service';

export class IProps {
    travelRequests!: ITravelRequest[];

    singleTravelRequest!: ITravelRequest | null;
    approvalResponse!: IApprovalTravelRequest[];
    loadingSingle!: boolean;
    loading!: boolean;
    error!: string | null;
}

@State<IProps>({
    name: 'travelRequest',
    defaults: {
        travelRequests: [],
        approvalResponse: [],
        singleTravelRequest: null,
        loadingSingle: false,
        loading: false,
        error: null
    }
})
@Injectable()
export class TravelRequestsStore {
    requestsService: TravelRequetService = inject(TravelRequetService);
    private store: Store = inject(Store);

    @Selector()
    static getRequests(state: IProps) {
        return state.travelRequests;
    }
    @Selector()
    static getApprovalRequests(state: IProps) {
        return state.approvalResponse;
    }
    @Selector()
    static singleRequest(state: IProps) {
        return state.singleTravelRequest;
    }

    @Selector()
    static getUserRequests(state: IProps) {
        return state.travelRequests;
    }

    @Selector()
    static loading(state: IProps) {
        return state.loading;
    }

    @Action(GetAllRequests)
    getAllRequest(ctx: StateContext<IProps>, action: GetAllRequests) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getRequests(action.queryParams as any).pipe(
            tap((res) => {
                ctx.patchState({
                    travelRequests: res,
                    loading: false,
                    error: null
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(CreateTravelForm)
    createTravel(ctx: StateContext<IProps>, action: CreateTravelForm) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.createTravelForm(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    travelRequests: [...state.travelRequests, res],
                    singleTravelRequest: res,

                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    error: err.message,
                    loading: false
                });
                throw err;
            })
        );
    }

    @Action(GetSingleTravelRequest)
    getOneRequest(ctx: StateContext<IProps>, action: GetSingleTravelRequest) {
        const state = ctx.getState();
        ctx.patchState({ loadingSingle: true });

        return this.requestsService.getSingle(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    singleTravelRequest: res,
                    loadingSingle: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loadingSingle: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(GetTravelRequestByUser)
    getByUser(ctx: StateContext<IProps>, action: GetTravelRequestByUser) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getByUser(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    travelRequests: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    // @Action(AddTravelRequestComment)
    // addComment(ctx: StateContext<IProps>, action: AddTravelRequestComment) {
    //     const state = ctx.getState();
    //     ctx.patchState({ loading: true });

    //     return this.requestsService.comment(action.input).pipe(
    //         tap((res) => {
    //             ctx.patchState({
    //                 // requests: state.requests?.map((r)=>r.id===action.input.remarkId?{...r,...action.input as any}:r) ,
    //                 loading: false
    //             });
    //         }),
    //         catchError((err) => {
    //             ctx.patchState({
    //                 loading: false,
    //                 error: err.message
    //             });
    //             throw err;
    //         })
    //     );
    // }
    @Action(GetTravelRequestByApprovers)
    getApproverRequest(ctx: StateContext<IProps>, action: GetTravelRequestByApprovers) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getApproverRequests(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    approvalResponse: res,
                    // requests: state.requests?.map((r)=>r.id===action.input.remarkId?{...r,...action.input as any}:r) ,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
}
